import {Injectable} from '@angular/core';
import {RestUserService} from '@app/core/api/rest.user.service';
import {PayloadUtil} from '@app/core/util/payload.util';
import {Kontakt} from '@pezi/entities';
import moment from 'moment';
import {Observable} from 'rxjs';
import {map, tap} from 'rxjs/operators';
import {KontakteStore, KontaktWithID} from './kontakte.store';
import {getAllEntities, selectAllEntities, setEntities} from "@ngneat/elf-entities";
import {select} from "@ngneat/elf";

@Injectable({providedIn: 'root'})
export class KontakteService {

  KONTAKTE_VALID_IN_MINUTES = 60 * 24;

  request$ = this.userService.getUserKontakte()
    .pipe(
      map(kontakte => {
        if (PayloadUtil.checkPayload(kontakte)) {
          return kontakte.data;
        }
        return [];
      }),
      tap(kontakte => {
        if (kontakte && kontakte.length) {
          let storeKontakte: KontaktWithID[] = kontakte.map(k => {
            let storeKontakt: Partial<KontaktWithID> = {};
            storeKontakt = Object.assign(k, storeKontakt)
            storeKontakt.id = k.userid;
            const validUntil = moment().add(this.KONTAKTE_VALID_IN_MINUTES, 'minutes');
            storeKontakt.validUntilInMs = validUntil.valueOf();
            return storeKontakt as KontaktWithID;
          })
          this.kontakteStore.data.update(setEntities(storeKontakte));
        }
      })
    );

  constructor(private kontakteStore: KontakteStore,
              private userService: RestUserService) {
  }

  getKontakte(): Observable<Kontakt[]> {
    if (this.canLoadKontakteFromCache()) { // gibts gecachte Daten und sind diese noch gültig
      return this.kontakteStore.data.pipe(selectAllEntities())
    }
    return this.request$;
  }

  canLoadKontakteFromCache(): boolean {
    const store = this.kontakteStore.data.getValue();
    return store && this.kontakteStore.data.query(getAllEntities()).length > 0 &&
      moment(this.kontakteStore.data.query(getAllEntities())[0].validUntilInMs).isAfter(moment());
  }

  clearKontakteStore() {
    this.kontakteStore.data.reset();
  }
}
